module.exports = __webpack_public_path__ + "static/img/building.0a7f24a7.jpg";